// extracted by mini-css-extract-plugin
export default {"hidden":"Modal_hidden__2YfUz","overlay":"Modal_overlay__rQGSK","modal":"Modal_modal__7Omag","closeButton":"Modal_closeButton__hgssU"};